import { render } from "./AppDatepicker.vue?vue&type=template&id=38cb5a03"
import script from "./AppDatepicker.vue?vue&type=script&lang=js"
export * from "./AppDatepicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__